module.exports = __webpack_public_path__ + "img/stage-sell-offer.8231cf68.png";